export const TECH_STACK = {
  typeScript: {
    src: './assets/ext/github/topics/typescript/typescript.webp',
    description: 'TypeScript'
  },
  node: {
    src: 'https://avatars.githubusercontent.com/u/9950313?s=200&v=4',
    description: 'NodeJs'
  },
  npm: {
    src: './assets/ext/github/topics/npm/npm.webp',
    description: 'Npm'
  },
  express: {
    src: './assets/ext/github/topics/express/express.webp',
    description: 'ExpressJs'
  },
  postgreSql: {
    src: './assets/ext/github/topics/postgresql/postgresql.webp',
    description: 'PostgreSQL'
  },
  mongoDb: {
    src: 'https://avatars.githubusercontent.com/u/45120?s=200&v=4',
    description: 'MongoDb'
  },
  heroku: {
    src: 'https://avatars.githubusercontent.com/u/23211?s=200&v=4',
    description: 'Heroku'
  },
  angular: {
    src: 'https://avatars.githubusercontent.com/u/139426?s=200&v=4',
    description: 'Angular'
  },
  fontAwesome: {
    src: 'https://avatars.githubusercontent.com/u/1505683?s=200&v=4',
    description: 'Font Awesome'
  },
  sass: {
    src: './assets/ext/github/topics/sass/sass.webp',
    description: 'Sass'
  },
  markdown: {
    src: './assets/ext/github/topics/markdown/markdown.webp',
    description: 'Markdown'
  },
  reactNative: {
    src: './assets/ext/github/topics/react-native/react-native.webp',
    description: 'React Native'
  },
  linkedIn: {
    src: './assets/third-parties/logo/linkedin.webp',
    description: 'LinkedIn'
  },
  gitHub: {
    src: './assets/third-parties/logo/github.webp',
    description: 'GitHub'
  },
  stackOverflow: {
    src: './assets/third-parties/logo/stackoverflow.webp',
    description: 'Stack Overflow'
  }
};
